
export const VocabContactWidget = {
    contact_information: ['Informacion de contacto', 'Contact information'],
    phone_numbers: ['Numeros telefonicos', 'Phone numbers'],
    phone_number: ['Numero telefonico', 'Phone number'],
    emergency_contacts: ['Contactos de emergencia', 'Emergency contacts'],
    name_placeholder : ['Nombre ', 'Name'],
    code_placeholder : ['Lada ', 'Code'],
    phone_placeholder : ['Numero', 'Number'],
    error_saving: ["Error al guardar", "Error while saving"],
    loading_data: ["Cargando...", "Loading..."],
  }
    